'use client';

import { fetchAppLogin } from '@module/apis/client-side/applogin/index';
import type { FetchAppLoginParams } from '@module/apis/client-side/applogin/type';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import catchAllErrors from '@module/utils/catchAllErrors';
import delay from '@module/utils/delay';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import { useEffect } from 'react';
import useModalStore from '../../stores/useModalStore';
import { MODAL_TYPE_MOBILE } from '../../types/modal/type';
import removeSearchParams from '../../utils/removeSearchParams';
export default function AppLoginTrigger() {
  const {
    pushModal
  } = useModalStore();
  const {
    refetchLoginInfo
  } = useGetLoginInfoQuery();
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const appSession = searchParams.get('app_session');
    const appUserIdx = searchParams.get('app_userIdx');
    if (!appSession || !appUserIdx) return;
    const loadAppLogin = async () => {
      const params: FetchAppLoginParams = {
        userIdx: Number(appUserIdx),
        session: appSession
      };
      try {
        await fetchAppLogin(params);
        // 처리 완료 전 1초 대기
        await delay(1000);
        refetchLoginInfo();
        // 로그인 처리 후 app_session, app_userIdx 쿼리 파라미터 제거
        removeSearchParams(['app_session', 'app_userIdx']);
      } catch (err) {
        if (err instanceof BaseHttpResponseError) {
          catchAllErrors(err.message, () => {
            pushModal({
              type: MODAL_TYPE_MOBILE.CONFIRM_MODAL,
              id: 'AppLoginTrigger',
              options: {
                description: err.message
              }
            });
          });
        }
      }
    };
    void loadAppLogin();
  }, []);
  return null;
}